export function handleClickedOutsideMainMenu(
    accountNavigationReference: any,
    setExpandedNavigationItem: any
) {
    return function handleClickedOutsideMainMenuInner(event: MouseEvent): void {
        if (
            (accountNavigationReference.current as any).contains(event.target)
        ) {
            return;
        }
        setExpandedNavigationItem(undefined);
    };
}
